import amplitude from 'amplitude-js';

export default amplitude;
